import src from "IMAGE";
export default { src, width: 949, height: 283, blurWidth: 0, blurHeight: 0};
